import { useEffect } from "react";
import { usePendingEdits } from "./pending-edits";

// Subscribes to the PendingEdits `saveTick`. The SaveBar bumps the tick
// once per successful commit cycle; any consumer of this hook closes its
// open editor in response.
//
// The tick is monotonic - no need to track a previous value. Partial
// failures do NOT bump the tick (SaveBar.signalSaved is only called on
// full success), so failed rows stay open with their inline error.
//
// Used by EditableRow and CareerGraph's RoleEditor - both previously had
// a hand-rolled copy of the same effect.

export function useAutoCloseOnSave(close: () => void): void {
  const ctx = usePendingEdits();
  const saveTick = ctx?.saveTick ?? 0;
  useEffect(() => {
    // External signal driving a local close. close is intentionally not
    // a dep - we react to the tick, not the callback identity (which
    // changes every render in most callers).
    close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveTick]);
}
